import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';

import './style.css';

export default class Button extends React.Component {
  static propTypes = {
    waitingState: PropTypes.object,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    color: PropTypes.string,
    to: PropTypes.string,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.noMoreWaiting = this.noMoreWaiting.bind(this);
    this.waitingState = this.waitingState.bind(this);
    this.getClasses = this.getClasses.bind(this);
    this.waitForAction = this.waitForAction.bind(this);

    this.state = {
      waiting: false
    };

    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  waitForAction(promise) {
    if (this.state.waiting) return;

    if (!(promise instanceof Promise)) return;

    this.setState({ waiting: true });
    promise.then(this.noMoreWaiting, this.noMoreWaiting);

    return promise;
  }

  noMoreWaiting() {
    if (!this.mounted) return;

    this.setState({ waiting: false });
  }

  onClick(event) {
    if (this.props.disabled === true) return;
    if (this.props.onClick && !this.state.waiting) {
      this.waitForAction(this.props.onClick(event));
    }
  }

  // For firing clicks within javascript
  click(event) {
    this.onClick(event);
  }

  waitingState() {
    if (!this.state.waiting) return null;

    return <span className="button-status"><FontAwesome name="refresh" spin /></span>;
  }

  getClasses() {
    let btnClass = [
      'button',
      'button--small'
    ];

    if (this.props.color) btnClass.push(this.props.color);
    if (this.props.disabled === true) btnClass.push('disabled');
    if (this.props.className && this.props.className.length > 0) btnClass.push(this.props.className);

    return btnClass.join(' ');
  }

  getExtras() {
    return null;
  }

  render() {
    if (this.state.waiting && this.props.waitingState) return this.props.waitingState;

    return (
      <Link
        to={this.props.to}
        onClick={this.onClick}
        className={this.getClasses()}
        >
        <span>
          {this.props.children}{this.waitingState()}
        </span>
        {this.getExtras()}
      </Link>
    );
  } 
}



/** WEBPACK FOOTER **
 ** ./src/components/Button/button.js
 **/